import { NgModule } from '@angular/core';
import { AuditViewerComponent } from './components/audit-viewer/audit-viewer.component';
import { RouterModule } from '@angular/router';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';
import { AuditViewerService } from './services/audit-viewer.service';
import { WorklistModule } from '../worklist/worklist.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    DynamicFormModule,
    WorklistModule,
    RouterModule.forRoot([])
  ],
  declarations: [AuditViewerComponent],
  providers: [AuditViewerService]
})
export class AuditModule { }
